module.exports = __webpack_public_path__ + "static/mobile@2x-53442b4b6e175f1b5eff36591d74af4e.png";